import React from 'react';
import {
  SimpleGrid,
  FormControl,
  Stack,
  Radio,
  RadioGroup,
  Text as TextComponent,
  Box,
  Tag,
  Heading,
} from '@chakra-ui/react';
import { FormInputs } from '../types/formInputs';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';

type DailyAllowanceSectionProps = {
  setValue: UseFormSetValue<FormInputs>;
  watch: UseFormWatch<FormInputs>;
};

export const DailyAllowanceSection = ({
  setValue,
  watch,
}: DailyAllowanceSectionProps): JSX.Element => {
  return (
    <Box as="div">
      <Stack direction="row" pb={10}>
        <Tag borderRadius="full">3</Tag>
        <Heading as="h3" size="md">
          Dagpeningar
        </Heading>
      </Stack>
      <SimpleGrid columns={1} spacing={10}>
        <FormControl>
          <RadioGroup
            onChange={(value): void => setValue('perDiemOption', value)}
            value={watch('perDiemOption')}
          >
            <Stack direction="column">
              <Stack direction="row" alignItems="center">
                <Radio value="adrid-dagpeningar">
                  Fyrirtæki greiðir fyrir hótel, morgunverð og ferðir til og frá
                  flugvelli
                </Radio>
                <TextComponent fontSize="sm" color="grey">
                  Starfsmaður fær dagpeninga fyrir öðru en gistingu.
                </TextComponent>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Radio value="fullir-dagpeningar">
                  Starfsmaður greiðir fyrir gistingu, ferðir og uppihald
                </Radio>
                <TextComponent fontSize="sm" color="grey">
                  Starfsmaður fær fulla dagpeninga
                </TextComponent>
              </Stack>
            </Stack>
          </RadioGroup>
        </FormControl>
      </SimpleGrid>
    </Box>
  );
};
